/**
 * RelationNameHeader Component
 * Displays a user's avatar with optional role label above their name.
 * Uses ProfileAvatar for the Camino-branded fallback icons.
 */

import { Box, HStack } from "@chakra-ui/react";
import CDS from "design-system";
import ProfileAvatar from "components/ProfileAvatar";
import { ROLE_CONFIG } from "design-system/components/NamePill";
import { BasicUser, User } from "features/User/models";
import { RelationType } from "models/v2/onboardingJourneyNetworkRelation";

function titleCase(str: string): string {
  return str
    .split(" ")
    .map((w) => w.charAt(0) + w.slice(1).toLowerCase())
    .join(" ");
}

interface RelationNameHeaderProps {
  user: User | BasicUser;
  roles?: RelationType[];
  /** Avatar size — maps to Chakra Avatar sizes */
  size?: "2xs" | "xs" | "sm" | "md";
}

export default function RelationNameHeader({ user, roles = [], size = "xs" }: RelationNameHeaderProps) {
  return (
    <HStack spacing={2} align="center">
      <ProfileAvatar size={size} user={user as User} flexShrink={0} />
      <Box textAlign="left">
        {roles.length > 0 && (
          <CDS.Text10 fontWeight="600" color="gray.500" lineHeight="1.3">
            {roles.map((r) => titleCase(ROLE_CONFIG[r]?.label || r)).join(" · ")}
          </CDS.Text10>
        )}
        <CDS.Text12 fontWeight="medium" color="gray.800" lineHeight="1.3">
          {user.fullName}
        </CDS.Text12>
      </Box>
    </HStack>
  );
}
